import React from "react";
import MCQAnswerInput from "../aiAssessmentAnswerInputs/MCQAnswerInput";
import DescriptiveAnswerInput from "../aiAssessmentAnswerInputs/DescriptiveAnswerInput";
import CodingAnswerInput from "../aiAssessmentAnswerInputs/CodingAnswerInput";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";

interface AiAssessmentAnswerProps {
  handleCodingFullscreenToggle: () => void;
  isCodingFullscreen: boolean;
}

const AiAssessmentAnswer: React.FC<AiAssessmentAnswerProps> = ({
  handleCodingFullscreenToggle,
  isCodingFullscreen,
}) => {
  const { currentStep, aiAssessmentQuestions } = useAIAssessmentContext();
  const question = aiAssessmentQuestions[currentStep];

  const getAnswerInput = () => {
    switch (question.answerType.toLowerCase()) {
      case "mcq":
        return <MCQAnswerInput />;
      case "descriptive":
        return <DescriptiveAnswerInput />;
      case "coding":
        return (
          <CodingAnswerInput
            handleCodingFullscreenToggle={handleCodingFullscreenToggle}
            isCodingFullscreen={isCodingFullscreen}
          />
        );
    }
  };
  return <div>{getAnswerInput()}</div>;
};

export default AiAssessmentAnswer;
